export default {
  "content": "<path d=\"M9.717.786a.424.424 0 01.587-.001L20 10.284l-1.67 1.837-8.028-7.865a.419.419 0 00-.583 0l-8.036 7.865L0 10.318 9.717.786z\" fill=\"#1A1A1A\"/><path d=\"M9.712 12.024a.41.41 0 01.579 0l4.233 4.208-1.003 1.102-3.459-3.363a.087.087 0 00-.121 0l-3.437 3.363L5.5 16.232l4.213-4.208z\" fill=\"#1A1A1A\"/><path d=\"M9.73 6.888a.415.415 0 01.586 0l6.715 6.648-1.261 1.356-5.568-5.416a.26.26 0 00-.357 0l-5.6 5.416-1.261-1.356L9.73 6.888z\" fill=\"#1A1A1A\"/>",
  "attrs": {
    "viewBox": "0 0 20 18",
    "width": "22",
    "height": "22",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};